import { fromJS } from 'immutable';
import { DRAW_PRIZE, END_DRAW_PRIZE } from './constants';

export const drawPrize = (prizePosition) => ({
  type: DRAW_PRIZE,
  payload: fromJS({ prizePosition }),
});

export const endDrawPrize = () => ({
  type: END_DRAW_PRIZE,
});
